import { ProductCodeRange } from "./LeadProducts";
import { DistributionChannel } from "./distributionChannelType";

export class SurveyModel {
  public QuestionId: number;
  public QuestionTag?: string;
  public SurveyCode: number;
  public SectionId: number;
  public IsFirstQuestionFromSection: boolean;
  public HeaderTextFr?: string;
  public HeaderTextNl?: string;
  public SubHeaderTextFr?: string;
  public SubHeaderTextNl?: string;
  public QuestionTextFr?: string;
  public QuestionTextNl?: string;
  public ScreenTypeCode: ScreenTypeCode;
  public ResponseDefaultValue?: string;
  public StaticScreenId: string;
  public TipFr?: string;
  public TipNl?: string;
  public TipImageReference?: string;
  public WhyThisQuestionFr?: string;
  public WhyThisQuestionNl?: string;
  public MinValue?: number;
  public MaxValue?: number;
  public PrefillQuote: string;
  public PrefillUser: string;
  public OverlayHeaderTextFr?: string;
  public OverlayHeaderTextNl?: string;
  public OverlayContentFr?: string;
  public OverlayContentNl?: string;
  public PreviousAnswerValue?: string | number;
  public RadioButtonValueList: RadioButtonModel[];
  public NextQuestionId?: number;
  public NextSectionId?: number;
  public RuleEngineName: string;
  public PreviousQuestionId?: number;
  public PreviousSectionId?: number;
  public ValidationList: QuestionValidationModel[];
  public NextQuestionSurveyCode : number;
  public PreviousQuestionSurveyCode: number;
  public SaveInDb: boolean;
  public IsLastQuestionOftheModule: boolean;
}

export class QuestionValidationModel {
  public ValidationCheckName: string;
  public MessageContentFr: string;
  public MessageContentNl: string;
}

export class RadioButtonModel {
  public AnswerId: number;
  public AnswerTag?: string;
  public ContentFr: string;
  public ContentNl: string;
  public NextQuestionId?: number;
  public NextSectionId?: number;
  public DescriptionFR?: string;
  public DescriptionNL?: string;
  public Icon?: string;
  public TitleFR?: string;
  public TitleNL?: string;
  public NextQuestionSurveyCode: number;
  public RuleEngineNameAnswer: string;
}

export class SustainabilityRadioList {
  public AnswerId: number;
  public OptionName: string;
  public OptionDesc: string;
}

export enum ScreenTypeCode {
  YesNo = 1,
  TextBox = 2,
  RadioButtons = 3,
  Counter = 4,
  CardsWithIcons= 5,
  Checkbox = 6,
  StaticScreen = 9
}

export enum AnswerType {
  Unknown = 0,
  String = 1,
  Integer = 2,
  Bool = 3,
  Double = 4,
  LeadContent = 5,
  ListOfIntegers = 6,
  Decimal = 7,
  ListOfLeadContent = 8
}

export enum BlockingType {
  None = 0,
  Partial = 1,
  Full = 2
}

export class SurveyAnswerModel {
  public SimulationId: number;
  public LeadQuestionId: number;
  public AnswerType: AnswerType;
  public SectionId: number;
  public AnswerValue: number | string;
  public RuleEngineName?: string;
  public NextQuestionId?: number;
  public NextSectionId?: number;
  public SurveyCode: number;
  public AnswerTag?: string;
  public QuestionTag?: string;
}

export interface NextNavigationModel {
  NextQuestionId: number;
  NextSectionId: number;
  DefaultValue?: string | number;
  NextQuestionSurveyCode: number;
  IsUrlRedirection: boolean;
  NextUrlRedirectionFR: string;
  NextUrlRedirectionNL: string;
}

export class SurveyBlockedScreen {
  static readonly FatcaBlocked = 'BlockUserFatca';
  static readonly CrsBlocked = 'BlockUserCRS';
  static readonly FinancialBlocked = 'BlockUserNeedAnalysis';
  static readonly FinancialConsistencyCheck = 'BlockUserFinancialCheckConsistency';
  static readonly UserCheckConsistency = 'BlockUserCheckConsistency';
  static readonly KnowledgeFrozenNotOver = 'KnowledgeFrozenPeriodNotOver';
  static readonly KnowledgeAlreadyTaken = 'KnowledgeAlreadyPassed';
  static readonly KnowledgeFailed = 'KnowledgeFailed';
  static readonly KnowledgeFrozenPeriod = 'KnowledgeFrozenPeriod';
  static readonly AreYouSureConsistency = 'BlockUserAreYouSureConsistency';
  static readonly NegativeAdvice = 'NegativeAdvice';
  static readonly BlockingScreenLtsProduct = 'BlockingScreenLtsProduct';
  static readonly BlockingScreenMortgageAndLoans = "BlockingScreenMortgageAndLoans";
  static readonly BlockingScreenProfessionalIncome = "BlockingScreenProfessionalIncome";
  static readonly BudgetFinancialConsistencyCheckBlockingScreen = "BudgetFinancialConsistencyCheckBlockingScreen";
  static readonly BlockingScreenDuration = "BlockConfirmDurationZennie";
  static readonly BlockUserNeedAnalysisZennie = "BlockUserNeedAnalysisZennie";
  static readonly BlockUserNeedAnalysisOther = "BlockUserNeedAnalysisOther";
  static readonly BlockingBudgetConsistency ="BlockingScreenUnder1000revenue";
  static readonly KnowledgeAlreadyTakenLTS = 'KnowledgeAlreadyPassedZennie';
  static readonly KnowledgeFailedLTS = 'KnowledgeFailedZennie';
  static readonly BlockUserSustainabilityUppie = 'BlockUserSustainabilityUppie';
  static readonly BlockUserFatcaYongo = 'BlockUserFatcaYongo';
  static readonly BlockUserCRSYongo = 'BlockUserCRSYongo';
  static readonly BlockUserNeedsUppieYongo = "BlockUserNeedsUppieYongo";
  static readonly BlockUserNeedsOtherYongo = "BlockUserNeedsOtherYongo";
  static readonly SelectYongoProduct = 'SelectYongoProduct';
  static readonly KnowledgeExperienceFeedbackYongo = 'KnowledgeExperienceFeedbackYongo'
}

export interface KnowledgeQuestionModel {
  BranchId: number;
  DecisionTreeQuestionViewModelList: SurveyModel[];
  IsNextKnowledgeSectionVisible: boolean;
  IsPassed: boolean;
  PersonId: number;
  ScenarioId: number;
}

export interface KnowledgeCheckModel {
  BranchId: number;
  IsNextKnowledgeSectionVisible: boolean;
  IsPassed: boolean;
  PersonId: number;
  ScenarioId: number;
  SectionId: number;
  surveyCode: number;
}

export class KnowledgeAnswerViewModel {
  SimulationId: number;
  PersonId: number;
  SectionId: number;
  IsPassed: boolean;
  LeadSurvey: number 
}

export class BlockedScreenLabels {
  IntroText?: string;
  title: string;
  desc: string;
  desc2?: string;
  desc3?: string;
  CtaText: string;
  CtaTextSecondary?: string;
  tipTitle?: string;
  SecondaryCtaText?: string;
  ImageUrl?: string;
  BlockMode: BlockingType;
}

export class RecommendationModel {
  Context: number;
  Duration: number;
  MonthlyAmount: number;
  OneShotAmount: number;
  permittedProductId?: number;
  ScenarioId: number;
  SimulationId: number;
  SurveyCode: number;
  SectionId: number;
}

export class FinancialCheckModel {
  oneShotAmount: number;
  monthlyAmount: number;
  duration: number;
}

export interface SummaryModel {
  QuoteDetailsId: number;
  SectionId: number;
  QuestionId: number;
  QuestionTextFr: string;
  QuestionTextNl: string;
  AnswerId: number;
  AnswerTextFr: string;
  AnswerTextNl: string;
  AnswerType: number;
  LevelAnswerIdentifier?:number;
  LeadQuestionLevel?:number;
}

export interface AdviceSummaryModel{
  AdviceSummaryViewModelList: SummaryModel[];
  IsAlreadyKnowledgeTestPassed: boolean;
}

export interface SimulationSessionData {
  BranchId: number;
  ScenarioId?: number;
  SurveyId: number;
  Duration: number;
  OneShotAmount: number;
  MonthlyAmount: number;
  SelectedProductTypeCode: string;
  Experience: boolean;
  PartnershipId: number;
  IsSimulationActive: boolean;
  IsNearlyEndOfYear: boolean;
  IsEndOfYear: boolean;
  MinDuration: number;
  MaxDuration: number;
  MinOneShotPremium: number;
  MaxOneShotPremium: number;
  MinRecurrentPremium: number;
  MaxRecurrentPremium: number;
  ProductRangeCode: ProductCodeRange;
  BeneficiaryChild: BeneficiaryChild;
}

export class BeneficiaryChild{
  LastName: string;
  FirstName: string;
  DateOfBirth: string;
  SubscriberId: number;
  Relationship: Relationship;
  SurveyCode?: number;
  LastStepSaved?: number;
}

export enum Relationship{
  Other = 0,
  Parent = 1,
  Grandparent = 2,
  Godparent = 3
}

export enum BudgetCappingType {
  Financial = 1,
  Calculated = 2,
  Estimated = 3,
  Absolute = 4
}

export interface CappingModel {
  IsCalculationAllowed: boolean,
  IsCalculationDone: boolean,
  MaxAmount: number,
  MaxAmountmonthly: number,
  CeilingType: BudgetCappingType,
  CeilingTypeAmount: number,
  CeilingTypeMonthlyAmount: number,
  CurrentYear: number,
  AbsoluteAmount: number,
  AbsoluteAmountMonthly: number
}

export enum LtsFrequencyType {
  Frequency = 1,
  Amount_Frequency = 2
}

export interface CatchUpPremium {
  IsFinancialBlockingPopup: boolean,
  IsCalculatedCelingBlockingPopup: boolean,
  IsWarningPopup: boolean,
  IsCatchupPremiumAllowed: boolean,
  CatchUpPremiumAmount: number,
  MonthlyPremiumAmount: number,
  NoOfMonth: number,
  CurrentYear: string
}

export type KnowledgeFeedbackModel = {
  IsFirstTimePassed: boolean,
  IsKnowledgeOK: boolean,
  IsExperienceOK: boolean,
  ChildName: string,
  ProductName: string,
  BranchId: number
}

export type SurveySessionWindow ={
  timeStamp: number,
  createSurvey: boolean
}

export class InitiateprojectionToolReqObj {
    distcha: DistributionChannel;
    partcdRange: ProductCodeRange;
    partcd?: string;
    ProductCd?: string;
    ProductFormulaCd?: string;
}